import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Tab, Nav, Form, Button, Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import ReactSlider from "react-slider";
import { useLocation } from "react-router-dom"; // <-- for reading URL params
import Sidebar from "./Sidebar";
import axios from "axios";
import { useProfile } from "../contexts/ProfileContext";
import Balance from "./Balance";
import { API_BASE_URL } from '../config/api';
import axiosClient from "../api/axiosClient";
import Alert from "./Alert";


const DeliveryDashboard = () => {
  const profile = useProfile(); 
  const [followersValue, setFollowersValue] = useState(0);
  const [likesValue, setLikesValue] = useState(0);
  const [viewsValue, setViewsValue] = useState(0);
  const [commentsValue, setCommentsValue] = useState(0);
  const [postLink, setPostLink] = useState("");
  const [orders, setOrders] = useState([]);
  const [orderTable, updateOrderTable ] = useState([]);
  const [price, setPrice] = useState(0);
  const [normalPrice, setNormalPrice] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [balanceModal, setBalanceModal] = useState(false);
  const [platform, setPlatform] = useState("instagram");
  const [comments, setComments] = useState("");
  const [min, setMin] = useState(0);
  const [posts, setPosts] = useState([]);
  const [cursors, setCursors] = useState({0: 0});
  const [currentPage, setCurrentPage] = useState(0);

  const [selectedPost, setSelectedPost] = useState(null);

  const [functionError, setFunctionError] = useState("");
  const [functionSuccess, setFunctionSuccess] = useState("");


  // Read "mode" from query param (?mode=likes/views/comments)
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const modeParam = queryParams.get("mode");

  // We'll ensure it's one of the 3 valid tabs; otherwise default to "likes"
  const validModes = ["likes", "views", "comments", "followers"];
  const defaultKey = validModes.includes(modeParam) ? modeParam : "followers";
 
  const [service, setService] = useState(defaultKey)
  // Handler for "Start Delivery"
  const handleStartDelivery = async (type) => {
		try {
		let selectedValue;
		if (type === "likes") selectedValue = likesValue;
		if (type === "views") selectedValue = viewsValue;
		if (type === "comments") selectedValue = commentsValue;
		if (type === "followers") selectedValue = followersValue;
		

		var finalLink = postLink;
		if (selectedPost) {
			finalLink = selectedPost;
		}

		
		const data = {
			"serviceId": platform + "-" + type,
			"link": finalLink,
			"quantity": selectedValue,
			"comments": comments
		}
    var createOrder = await axiosClient.post("https://api.viralgpt.com/boosts/order", data);
		updateOrderTable("!");
		profile.balance = profile.balance - selectedValue;
		setFunctionSuccess(`Starting delivery for ${type}!\nAmount: ${selectedValue}\nPost Link: ${postLink}\nCharge: $${price}`);
    setTimeout(() => {
      window.location.reload();
    }, 1500);
	} catch (e) {
		setFunctionError("Failed to create order: " + e.response.data.error)
		if (e.response.data.error === "Insufficient balance"){
			setBalanceModal(true)
		}
	}
  };

  const [prices, setPrices] = useState([]);
  const getPrices = async () => {
	try {
		const response = await axios.get("https://api.viralgpt.com/boosts/prices");
		setPrices(response.data);
	} catch (e) {
		console.error("Failed to get prices: " + e);
	}
  }

  useEffect(() => {
	getPrices();
  }, []);

const [loadingPage, setLoadingPage] = useState(false);
const [loadingPosts, setLoadingPosts] = useState(false);
const getPosts = async (page) => {
	try {
		if (page == 0) {
			setLoadingPosts(true)
			setCurrentPage(0)
		}
		var cursor = page === 0 ? 0 : cursors[page - 1];
		setLoadingPage(true)
		const response = await axios.post("https://api.viralgpt.com/boosts/posts", {
			"username": postLink,
			"platform": platform,
			"cursor": cursor
		}, {
			headers: {
				"Authorization": `Bearer ${localStorage.getItem("accessToken")}`
			}
		});
		setPosts(response.data.posts);
		setCursors(cursors => ({...cursors, [page]: response.data.cursor}));
		
	} catch (e) {
		console.error("Failed to get posts: " + e);
	} finally {
		setLoadingPosts(false)
		setLoadingPage(false)
	}
}




  useEffect(() => {
	const updatePrice = async () => {
		let selectedValue;
		if (service === "likes") selectedValue = likesValue;
		if (service === "views") selectedValue = viewsValue;
		if (service === "comments") selectedValue = commentsValue;
		if (service === "followers") selectedValue = followersValue;
		
		const serviceKey = platform + "-" + service;
		setMin(prices[serviceKey].min);
	

		if (prices[serviceKey]) {

			if (Object.values(profile?.socials || {}).some(social => social.planName === "pro")) {
				setPrice(((prices[serviceKey].pro / 1000) * selectedValue).toFixed(2) );
			} else {
				setPrice(((prices[serviceKey].price / 1000) * selectedValue).toFixed(2) );
			}
			setNormalPrice(((prices[serviceKey].price / 1000) * selectedValue).toFixed(2) );
			setQuantity(selectedValue);
		}
	}
	if (Object.keys(prices).length > 0) {
		updatePrice();
	}
  }, [likesValue, viewsValue, commentsValue, followersValue, service, platform, prices, profile.planName]);

  useEffect(() => {
	const getOrders = async () => {
	  const accessToken = localStorage.getItem("accessToken");
	  if (!accessToken) return false;
	
	  try {
		console.log(accessToken)
		const response = await axios.get("https://api.viralgpt.com/boosts/order/status", {
		  headers: {"Authorization": `Bearer ${localStorage.getItem("accessToken")}`}
		});
	
		setOrders(response.data);
		return response.data
	  } catch (err) {
		console.error("Authentication check failed:", err);
		return false;
	  }
	};
	 getOrders();
  }, [orderTable]);


  useEffect(() => {
	setCurrentPage(0)
	setCursors({0: 0})
	setPosts([])
	setSelectedPost(null)
  }, [postLink, platform, service]);

  return (
	<>
	<Balance show={balanceModal} onHide={() => setBalanceModal(false)} profile={profile} />
      <Container className="py-2  px-2 col-md-8">
		{/*
        <h1 className="text-4xl font-bold text-gray-800">
          <span className="text-instagram">ViralGPT</span> Booster
        </h1>
        <p className="text-muted">
          Send instant engagement to any profile or post.
          <br />
        </p>
		*/}
        <Alert 
          variant="danger" 
          message={functionError} 
          show={!!functionError} 
          onClose={() => setFunctionError("")} 
        />

		    <Alert 
          variant="success" 
          message={functionSuccess} 
          show={!!functionSuccess} 
          onClose={() => setFunctionSuccess("")} 
        />
        {/* Tabs Section */}
		
        <Tab.Container activeKey={service}>
		
		<div class="row">
			
          <Tab.Content className="bg-white border">
		  <div className="row">
          <div className="bg-white border rounded-lg p-2 d-flex flex-wrap w-100">
            <div className="col-6 col-lg-3 p-1">
              <div 
                onClick={() => setService("followers")}
                className={`text-center py-3 rounded-lg transition-all duration-200 hover:shadow-md cursor-pointer ${service === "followers" ? "border-instagram " : "border"}`}
              >
                <i className={`fas fa-users text-instagram me-2`}></i>
                <span>Followers</span>
              </div>
            </div>
            <div className="col-6 col-lg-3 p-1">
              <div 
                onClick={() => setService("likes")} 
                className={`text-center py-3 rounded-lg transition-all duration-200 hover:shadow-md cursor-pointer ${service === "likes" ? "border-instagram " : "border"}`}
              >
                <i className={`fas fa-heart text-instagram me-2`}></i>
                <span>Likes</span>
              </div>
            </div>
            <div className="col-6 col-lg-3 p-1">
              <div 
                onClick={() => setService("views")} 
                className={`text-center py-3 rounded-lg transition-all duration-200 hover:shadow-md cursor-pointer ${service === "views" ? "border-instagram " : "border"}`}
              >
                <i className={`fas fa-eye text-instagram me-2`}></i>
                <span>Views</span>
              </div>
            </div>
            <div className="col-6 col-lg-3 p-1">
              <div 
                onClick={() => setService("comments")} 
                className={`text-center py-3 rounded-lg transition-all duration-200 hover:shadow-md cursor-pointer ${service === "comments" ? "border-instagram " : "border"}`}
              >
                <i className={`fas fa-comment text-instagram me-2`}></i>
                <span>Comments</span>
              </div>
            </div>
          </div>
		</div>
		  {/* Platform Selection */}
		  <Form.Group controlId="platform" className="mb-3 px-2 pt-4">
                  <Form.Label>Choose Platform</Form.Label>
                  <div className="justify-content-center">
                    <div className="row row-cols-2 row-cols-lg-4 row-cols-md-2 g-2 text-center" >
                      <div className="col">
                        <div 
                          onClick={() => setPlatform("instagram")}
                          className={`platform-btn ${platform === "instagram" ? "bg-instagram text-white" : "bg-light"} p-2 rounded cursor-pointer border`}
                          role="button"
                        >
                          <i className="fab fa-instagram me-2"></i>
                          <span>Instagram</span>
                        </div>
                      </div>
                      <div className="col">
                        <div
                          onClick={() => setPlatform("tiktok")}
                          className={`platform-btn ${platform === "tiktok" ? "bg-tiktok text-white" : "bg-light"} p-2 rounded cursor-pointer border`}
                          role="button"
                        >
                          <i className="fab fa-tiktok me-2"></i>
                          <span>TikTok</span>
                        </div>
                      </div>
                      <div className="col">
                        <div
                          onClick={() => setPlatform("youtube")}
                          className={`platform-btn ${platform === "youtube" ? "bg-danger text-white" : "bg-light"} p-2 rounded cursor-pointer border`}
                          role="button"
                        >
                          <i className="fab fa-youtube me-2"></i>
                          <span>YouTube</span>
                        </div>
                      </div>
                      <div className="col">
                        <div
                          onClick={() => setPlatform("x")}
                          className={`platform-btn ${platform === "x" ? "bg-dark text-white" : "bg-light"} p-2 rounded cursor-pointer border`}
                          role="button"
                        >
                          <span className="bg-dark px-1 rounded me-2 text-white">𝕏</span>
                          <span>Twitter</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form.Group>
		  <Tab.Pane eventKey="followers">
              <div className="rounded px-2">
                {/* Link Input */}
                <Form.Group controlId="likesLink" className="my-4">
					<Form.Label>
						{platform === "youtube" ? `${platform.charAt(0).toUpperCase() + platform.slice(1)} Profile Link` : `${platform.charAt(0).toUpperCase() + platform.slice(1)} Username`}
					</Form.Label>
				  <Form.Control
                      type="text"
                      placeholder={platform === "youtube"
                        ? `https://youtube.com/channel/<channel_id>`
                        : `Enter ${platform.charAt(0).toUpperCase() + platform.slice(1)} username here`}
                      value={postLink}
                      onChange={(e) => setPostLink(e.target.value)}
                    />
                </Form.Group>
             
                {/* Slider for Likes */}
                <div className="mb-3">
				<Form.Group controlId="followersLink" className="mb-3">
				  <Form.Label>Followers Amount (Min: {min})</Form.Label>
				  <Form.Control  max={5000} className="w-100" type="number" value={followersValue}  onChange={(val) => setFollowersValue(val.target.value)}></Form.Control>
				</Form.Group>
                  <ReactSlider
                    className="custom-slider"
                    thumbClassName="custom-thumb"
                    trackClassName="custom-track"
                    
                    max={5000}
                    value={followersValue}
                    onChange={(val) => setFollowersValue(val)}
                    renderTrack={(props, state) => (
                      <div
                        {...props}
                        style={{
                          ...props.style,
                          background:
                            state.index === 1
                              ? 'lightgray' // Before the first thumb
                              : state.index === 0
                              ? 'linear-gradient(45deg, #4b25ea, #bd18e6, #fb590e)' // Between the thumbs
                              : 'lightgray', // After the second thumb
                        }}
                      />
                    )}
                  />
                </div>

                {/* Start Delivery Button */}
				
            

              </div>
            </Tab.Pane>
            {/* Likes Tab */}
            <Tab.Pane eventKey="likes">
              <div className="rounded px-2">
                {/* Link Input */}
                <Form.Group controlId="likesLink" className="my-4">
                  <Form.Label>{(platform === "x" || platform === "youtube") ? `${platform.charAt(0).toUpperCase() + platform.slice(1)} Post Link` : `${platform.charAt(0).toUpperCase() + platform.slice(1)} Username`}</Form.Label>
                  <div className="d-flex">
                    <Form.Control
                      type="text"
                      placeholder={
                        platform === "youtube" ? "https://youtube.com/watch?v=<video_id>" :
                        platform === "x" ? "https://twitter.com/<username>/status/<tweet_id>" :
                        platform === "instagram" ? "Enter Instagram username here" :
                        platform === "tiktok" ? "Enter TikTok username here" :
                        "Enter username"
                      }
                      value={postLink}
                      onChange={(e) => setPostLink(e.target.value)}
                    />
                    {platform !== "x" && platform !== "youtube" && (
                      <Button 
                        variant="primary"
                        className="ms-2"
                        onClick={() => {
                          getPosts(0)
                        }}
                      >
                        {loadingPosts ? <><i className="fas fa-arrows-rotate fa-spin" disabled></i></> : <i className="fas fa-search"></i>}
                      </Button>
                    )}
                  </div>
                </Form.Group>
              
                {/* Slider for Likes */}
                <div className="mb-3">
				<Form.Group controlId="likesLink" className="mb-3">
				  <Form.Label>Likes Amount</Form.Label>
				  <Form.Control  max={5000} className=" w-100" type="number" value={likesValue}  onChange={(val) => setLikesValue(val.target.value)}></Form.Control>
				</Form.Group>
                  <ReactSlider
                    className="custom-slider"
                    thumbClassName="custom-thumb"
                    trackClassName="custom-track"
                    
                    max={5000}
                    value={likesValue}
                    onChange={(val) => setLikesValue(val)}
                    renderTrack={(props, state) => (
                      <div
                        {...props}
                        style={{
                          ...props.style,
                          background:
                            state.index === 1
                              ? 'lightgray' // Before the first thumb
                              : state.index === 0
                              ? 'linear-gradient(45deg, #4b25ea, #bd18e6, #fb590e)' // Between the thumbs
                              : 'lightgray', // After the second thumb
                        }}
                      />
                    )}
                  />
                </div>

                {/* Start Delivery Button */}
				
             
              </div>
            </Tab.Pane>

            {/* Views Tab */}
            <Tab.Pane eventKey="views">
              <div className="bg-white rounded px-2">
                {/* Link Input */}
                <Form.Group controlId="viewsLink" className="my-4">
                  <Form.Label>
                    {platform === "youtube" || platform === "x" ? `${platform.charAt(0).toUpperCase() + platform.slice(1)} Post Link` : `${platform.charAt(0).toUpperCase() + platform.slice(1)} Username`}
                  </Form.Label>
                  <div className="d-flex">
                    <Form.Control
                      type="text"
                      placeholder={
                        platform === "youtube" ? "https://youtube.com/watch?v=<video_id>" :
                        platform === "x" ? "https://twitter.com/<username>/status/<tweet_id>" :
                        platform === "instagram" ? "Enter Instagram username here" :
                        platform === "tiktok" ? "Enter TikTok username here" :
                        "Enter username"
                      }
                      value={postLink}
                      onChange={(e) => setPostLink(e.target.value)}
                    />
                    {platform !== "youtube" && platform !== "x" && (
                      <Button 
                        variant="primary"
                        className="ms-2"
                        onClick={() => {
                          getPosts(0)
                        }}
                      >
                        {loadingPosts ? <><i className="fas fa-arrows-rotate fa-spin" disabled></i></> : <i className="fas fa-search"></i>}
                      </Button>
                    )}
                  </div>
                </Form.Group>
               
                {/* Slider for Views */}
                <div className="mb-3">
                  
				<Form.Group controlId="viewsLink" className="mb-3">
				  <Form.Label>Views Amount</Form.Label>
				  <Form.Control  max={5000} className=" w-100" type="number" value={viewsValue}  onChange={(val) => setViewsValue(val.target.value)}></Form.Control>
				</Form.Group>
                  <ReactSlider
                    className="custom-slider"
                    thumbClassName="custom-thumb"
                    trackClassName="custom-track"
                    
                    max={5000}
                    value={viewsValue}
                    onChange={(val) => setViewsValue(val)}
                    renderTrack={(props, state) => (
                      <div
                        {...props}
                        style={{
                          ...props.style,
                          background:
                            state.index === 1
                              ? 'lightgray'
                              : state.index === 0
                              ? 'linear-gradient(45deg, #4b25ea, #bd18e6, #fb590e)'
                              : 'lightgray',
                        }}
                      />
                    )}
                  />
                </div>

              
              </div>
            </Tab.Pane>

            {/* Comments Tab */}
            <Tab.Pane eventKey="comments">
              <div className="bg-white rounded px-2">
              
              
                {/* Link Input */}
                <Form.Group controlId="commentsLink" className="my-4 ">
                  <Form.Label>
                    {platform === "youtube" || platform === "x" ? `${platform.charAt(0).toUpperCase() + platform.slice(1)} Post Link` : `${platform.charAt(0).toUpperCase() + platform.slice(1)} Username`}
                  </Form.Label>
                  <div className="d-flex">
                    <Form.Control
                      type="text"
                      placeholder={
                        platform === "youtube" ? "https://youtube.com/watch?v=<video_id>" :
                        platform === "x" ? "https://twitter.com/<username>/status/<tweet_id>" :
                        platform === "instagram" ? "Enter Instagram username here" :
                        platform === "tiktok" ? "Enter TikTok username here" :
                        "Enter username"
                      }
                      value={postLink}
                      onChange={(e) => setPostLink(e.target.value)}
                    />
                    {platform !== "youtube" && platform !== "x" && (
                      <Button 
                        variant="primary"
                        className="ms-2"
                        onClick={() => {
                          getPosts(0)
                        }}
                      >
                        {loadingPosts ? <><i className="fas fa-arrows-rotate fa-spin" disabled></i></> : <i className="fas fa-search"></i>}
                      </Button>
                    )}
                  </div>
                </Form.Group>

                {/* Custom Comments Input */}
                <Form.Group controlId="customComments" className="my-4"	>
                  <Form.Label>Custom Comments (1 per line)</Form.Label>
                  <Form.Control
                    as="textarea" 
                    rows={4}
                    placeholder="Enter custom comments here&#10;One comment per line"
                    style={{resize: "vertical"}}
                    onChange={(e) => {
                      const lines = e.target.value.split('\n').filter(line => line.trim() !== '').length;
                      setCommentsValue(lines);
					  setComments(e.target.value.replace(/\n/g, '|'));
                    }}
                  />
                </Form.Group>



             
              </div>
			
            </Tab.Pane>
			

			
				{posts.length > 0 && (
				<div className="mt-3 px-2">
					<h5 className="mb-3">Recent Posts</h5>
					<div className="row row-cols-2 g-2">
						{posts.map((post) => (
							<div key={post.post_id} className="col">
								<div className={`h-100 shadow-sm ${selectedPost === post.post_url ? 'border-instagram border-5 rounded' : 'card'}`} style={{fontSize: "0.8rem"}} onClick={() => setSelectedPost(post.post_url)}>
									<img 
										src={`https://rizzup.net/proxy/${encodeURIComponent(post.post_image)}`}
										className="card-img-top"
										alt="Post thumbnail"
										style={{height: "120px", objectFit: "cover"}}
									/>
									<div className="card-body p-2">
										<p className="card-text text-muted small mb-2" style={{
											overflow: "hidden",
											textOverflow: "ellipsis",
											display: "-webkit-box",
											WebkitLineClamp: "2",
											WebkitBoxOrient: "vertical",
											fontSize: "0.75rem"
										}}>
											{post.post_text}
										</p>
										<div className="d-flex justify-content-between text-muted">
											<span><i className="fas fa-heart me-1"></i>{post.post_likes}</span>
											<span><i className="fas fa-comment me-1"></i>{post.post_comments}</span>
											<span><i className="fas fa-eye me-1"></i>{post.post_views}</span>
										</div>
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			)}
			<div className="px-2 my-4" style={{display: posts.length > 0 ? "block" : "none"}}>
				<div className="d-flex justify-content-center align-items-center">
					<div className="d-flex align-items-center gap-3">
						<Button 
							variant="outline-primary"
							onClick={() => {
								if (currentPage > 0) {
									setCurrentPage(currentPage - 1);
									getPosts(currentPage - 1); 
								}
							}}
							disabled={currentPage === 0 || loadingPage}
							className="px-3 py-2"
						>
							<i className="fas fa-arrow-left"></i>
						</Button>

						<div className="d-flex align-items-center justify-content-center" style={{minWidth: "100px"}}>
							{loadingPage ? (
								<i className="fas fa-arrows-rotate fa-spin"></i>
							) : (
								<span className="text-muted fw-medium">Page {currentPage + 1}</span>
							)}
						</div>

						<Button 
							variant="outline-primary"
							onClick={() => {
								setCurrentPage(currentPage + 1);
								getPosts(currentPage + 1);
							}}
							disabled={!cursors[currentPage] || loadingPage}
							className="px-3 py-2"
						>
							<i className="fas fa-arrow-right"></i>
						</Button>
					</div>
				</div>
			</div>
          </Tab.Content>
		  
		  <div className="text-nowrap bg-white border" md={4}>
		  <div className=" p-4 pb-0 mb-4">
		 	 <h5>Order Summary</h5>
			 
			    {/* Start Delivery Button */}
				<div data-testid="order-summary">
				
      <ul className="flex select-text flex-col gap-2 ">
	  <li>
          <div className="flex items-center justify-between gap-24">
            <span>Price per {service.replace("s", "")}</span>
            <span className="max-w-[200px] break-words text-right font-semibold md:max-w-[400px]">${isNaN(normalPrice / quantity) ? 0 : (normalPrice / quantity).toFixed(3)}</span>
          </div>
        </li>
       
        <li>
          <div className="flex items-center justify-between gap-24">
            <span>Quantity</span>
            <span className="max-w-[200px] break-words text-right font-semibold md:max-w-[400px]">{quantity}</span>
          </div>
        </li>
		<li>
          <div className="flex items-center justify-between gap-24">
            <span>Price</span>
            <span className="max-w-[200px] break-words text-right font-semibold md:max-w-[400px]">${normalPrice}</span>
          </div>
        </li>
		{Object.values(profile?.socials || {}).some(social => social.planName === "pro") && (
        <li>
          <div className="flex items-center justify-between gap-24 text-brand-400 text-instagram">
            <span className="text-instagram"><strong>Pro Discount</strong></span>
            <span className="text-instagram max-w-[200px] break-words text-right font-semibold md:max-w-[400px]">-20%</span>
          </div>
        </li>
		)}
       
      </ul>
<hr></hr>
      <div>
        <div className="flex items-center justify-between gap-4">
          <span>Total price</span>
          {Object.values(profile?.socials || {}).some(social => social.planName === "pro") ? (
            <span className="text-xl font-bold "><strong>${price}</strong></span>
          ) : (
            <span className="text-xl font-bold"><strong>${price}</strong></span>
          )}
        </div>
      </div>
     
    </div>
    <div 
      className={`text-white text-center font-bold p-3 rounded w-100 mt-4 ${
        (!selectedPost && (platform === "instagram" || platform === "tiktok") && service !== "followers") 
          ? "bg-blue-500 cursor-not-allowed opacity-50" 
          : "bg-blue-500 cursor-pointer"
      }`}
      onClick={() => {
        if (!(!selectedPost && (platform === "instagram" || platform === "tiktok") && service !== "followers")) {
          handleStartDelivery(service)
        }
      }}
      disabled={!selectedPost && (platform === "instagram" || platform === "tiktok") && service !== "followers"}
    >
      {(!selectedPost && (platform === "instagram" || platform === "tiktok") && service !== "followers")
        ? "Choose a Post"
        : "Start Delivery"
      }
    </div>
	
    <div>
      <ul className="flex gap-6  py-2 justify-center mt-3">
        <li className="flex items-center">
          <i className="fa-solid fa-bolt mr-2 text-instagram"></i>
          <span>Instant start</span>
        </li>
        <li className="flex items-center">
          <i className="fa-solid fa-lock mr-2 text-instagram"></i>
          <span>No Password</span>
        </li>
		<OverlayTrigger
          placement="top"
          overlay={
            <Tooltip>
              Average delivery time
            </Tooltip>
          }
        >
          <li className="flex items-center cursor-help">
            <i className="fa-solid fa-clock mr-2 text-instagram"></i>
            <span>{prices[platform + "-" + service]?.averageTime}</span>
          </li>
        </OverlayTrigger>
      </ul>
    </div>
    </div>
    </div>
    </div>
        </Tab.Container>
      </Container>

      {/* Scrollable Orders Section */}
      <Container className="scrollable-container">
		<h1 className="text-2xl font-bold">Order History</h1>

		{orders.length === 0 && (
			<div className="text-center">
				<p>No orders found</p>
			</div>
		)}
        <div className="table-responsive">
          <div className="d-none d-md-block"> {/* Desktop view */}
            <Table bordered hover responsive>
              <thead>
                <tr className="booster-table">
                  <th>Service</th>
                  <th>Link</th>
                  <th>Charge</th>
                  <th>Start count</th>
                  <th>Amount</th>
                  <th>Remains</th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody className="booster-table">
                {orders.map((order, index) => (
                  <tr key={index}>
                    <td className="text-truncate" style={{maxWidth: "100px"}} title={order.boost_name}>
                      <i className={`fa-brands fa-${order.boost_type.split('-')[0]} me-1`}></i>
                      {order.boost_type.split('-')[1].charAt(0).toUpperCase() + order.boost_type.split('-')[1].slice(1)}
                    </td>
                    <td>
                      <a className="text-primary" href={order.link} target="_blank" rel="noopener noreferrer" title={order.link}>
                        <span className="text-truncate" style={{maxWidth: "100px"}}>
                          <i className="fa-solid fa-link"></i>
                        </span>
                      </a>
                    </td>
                    <td>${order.price}</td>
                    <td>{order.start_count || '-'}</td>
                    <td>{order.quantity || '-'}</td>
                    <td>{order.remains || '-'}</td>
                    <td>
                      <span className={`badge ${
                        order.status === 'Completed' ? 'bg-success' :
                        order.status === 'Pending' ? 'bg-yellow-500' :
                        order.status === 'In Progress' ? 'bg-blue-500' :
                        order.status === 'Partial' ? 'bg-orange-500' :
                        order.status === 'Canceled' ? 'bg-red-500' :
                        'bg-gray-500'
                      }`}>
                        {order.status}
                      </span>
                    </td>
                    <td>{new Date(order.created_at).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>

          {/* Mobile view */}
          <div className="d-md-none">
            {orders.map((order, index) => (
              <div key={index} className="card mb-3">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="card-subtitle text-muted">Service</h6>
                    <span>{order.boost_name}</span>
                  </div>
                  
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="card-subtitle text-muted">Link</h6>
                    <a className="text-primary" href={order.link} target="_blank" rel="noopener noreferrer">
                      {order.link?.length > 20 ? order.link.substring(0,20) + '...' : order.link}
                    </a>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="card-subtitle text-muted">Charge</h6>
                    <span>${order.price}</span>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="card-subtitle text-muted">Amount</h6>
                    <span>{order.quantity || '-'}</span>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="card-subtitle text-muted">Status</h6>
                    <span className={`badge ${
                      order.status === 'Completed' ? 'bg-success' :
                      order.status === 'Pending' ? 'bg-yellow-500' :
                      order.status === 'In Progress' ? 'bg-blue-500' :
                      order.status === 'Partial' ? 'bg-orange-500' :
                      order.status === 'Canceled' ? 'bg-red-500' :
                      'bg-gray-500'
                    }`}>
                      {order.status}
                    </span>
                  </div>

                  <div className="d-flex justify-content-between align-items-center">
                    <h6 className="card-subtitle text-muted">Date</h6>
                    <small>{new Date(order.created_at).toLocaleString()}</small>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </>
  );
};

export default DeliveryDashboard;
